function Spinner(){
return(
    <div className="space-y-2 flex justify-center items-center flex-col">
        <div className="spinner">

        </div>
        <div className="text-bgDark text-lg font-semibold">Loading...</div>
    </div>
)
}

export default Spinner;